export const BASE_URL = process.env.REACT_APP_API_KEY;
export const PROFILE_BASE_URL = process.env.REACT_APP_API_KEY;

export const CUSTOMER_FIND_MANY = BASE_URL + '/customers/find-many-profile';
export const COUNT_NUMBER_CUSTOMER = BASE_URL + '/customers/count-customer';
export const BAN_CUSTOMER = BASE_URL + '/credentials/ban'
export const IMAGE_CUSTOMER = PROFILE_BASE_URL + '/profile/api/';
